export default{
    Acount(context){
        context.commit('Mcount');
    }
}